(function() {
    'use strict';

    angular.module('user')
        .controller('AllowedIpCreateController', AllowedIpCreateController);

    AllowedIpCreateController.$inject = ['$state', 'allowedIpDataSrvc', 'notificationSrvc', 'allowedIpMessagesConst', 'errorNotificationSrvc'];

    function AllowedIpCreateController($state, allowedIpDataSrvc, notificationSrvc, allowedIpMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            ip: [],
            description: [],
            nonFieldErrors: []
        };
        self.allowedIpData = {
            ip: '',
            description: '',
        };

        self.createAllowedIp = createAllowedIp;
        self.cleanErrors = cleanErrors;

        function createAllowedIp() {
            allowedIpDataSrvc.create(
                self.allowedIpData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", allowedIpMessagesConst.add);
                    $state.go('layout.allowedIp.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
